import { Directive } from '@angular/core';

@Directive({
  selector: '[unityMainTile]',
})
export class MainTileDirective {}
